const anchor = CSS.escape(window.location.hash.slice(1));
document.querySelectorAll('.multi-accordion').forEach((element) => {
  const dosageForms = element.classList.contains('dosage-forms');
  if (!dosageForms && document.body.classList.contains('editmode')) {
    return;
  }
  const itemSelectors = element.querySelectorAll('.item-selector');
  itemSelectors.forEach((itemSelector) =>
    itemSelector.addEventListener('click', (event) =>
      element
        .querySelectorAll('.list-component-categories label')
        .forEach((label) => {
          label.querySelector('span').classList.toggle('active', label.getAttribute('for') === event.target.id);
          document.getElementById(label.getAttribute('for') + '-content').hidden = label.getAttribute('for') !== event.target.id;
        }
      )
    )
  );
  itemSelectors[0]?.click();
  if (dosageForms || !anchor) {
    return;
  }
  const faq_element = element.querySelector(`#collapse-${anchor}`) ?? element.querySelector(`#${anchor}`);
  if (!faq_element) {
    return;
  }
  let faq_container_id = anchor;
  if (faq_element.nodeName === 'DIV') {
    faq_element.classList.add('show');
    faq_container_id = CSS.escape(faq_element.parentElement.parentElement.parentElement.dataset.faqid);
  }
  if (faq_container_id) {
    element.querySelector(`#multi-accordion-item-${faq_container_id}`).click();
  }
  element.querySelector(`#${anchor}`).scrollIntoView(true);
});
